import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const AUTH_COOKIE_KEY = "vrs_auth_token";
export const AUTH_STORAGE_KEY = "vrs_auth_session";
const REQUIRED_ISSUER = "CoreCLS";

export const parseJwtPayload = (token) => {
	if (!token) return null;

	try {
		return jwtDecode(token);
	} catch {
		return null;
	}
};

export const isValidCoreClsToken = (token) => {
	const payload = parseJwtPayload(token);

	if (!payload) {
		return false;
	}

	if (payload.iss !== REQUIRED_ISSUER) {
		return false;
	}

	if (typeof payload.exp !== "number") {
		return false;
	}

	return payload.exp * 1000 > Date.now();
};

export const clearAuthSession = () => {
	Cookies.remove(AUTH_COOKIE_KEY);
	localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const getAuthToken = () => Cookies.get(AUTH_COOKIE_KEY) || "";

export const hasValidAuthSession = () => isValidCoreClsToken(getAuthToken());
